import type { Schema as UserSchema, PrivateProjection } from '@daresay/db/build/models/User';

export type { NotificationRecords } from '@daresay/db/build/models/User';

export type User = PrivateProjection<{ _id: string } & UserSchema>;

export const authKeys = ['daresay', 'apple', 'discord', 'facebook', 'google', 'reddit', 'steam', 'twitch'];

export const isAuthKey = (strategy: string): strategy is keyof User['auth'] => authKeys.includes(strategy);
